import {
  IPropertyReturn,
  MarketValueSource,
} from "../types/ownerDashboard.types";
import { normalizeKenloPropertyId } from "./buildPropertyLabelMap";

function asNullablePositiveNumber(value: unknown): number | null {
  if (value == null || value === "") {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function asFiniteNumber(value: unknown, fallback = 0): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function normalizeMarketValueSource(
  value: unknown,
  hasInformedMarketValue: boolean
): MarketValueSource {
  const source = String(value ?? "").toLowerCase();

  if (source === "informed" || source === "fipe_estimate") {
    return source;
  }

  return hasInformedMarketValue ? "informed" : "fipe_estimate";
}

export function normalizePropertyReturn(propertyReturn: IPropertyReturn): IPropertyReturn {
  const propertyLabel = propertyReturn.property_label?.trim();
  const propertyAddress = propertyReturn.property_address?.trim();
  const marketValue = asNullablePositiveNumber(propertyReturn.market_value);
  const estimatedCurrentValue = asFiniteNumber(
    propertyReturn.estimated_current_value,
    propertyReturn.purchase_value
  );
  const effectiveMarketValue = asFiniteNumber(
    propertyReturn.effective_market_value,
    marketValue ?? estimatedCurrentValue
  );

  return {
    ...propertyReturn,
    kenlo_property_id: normalizeKenloPropertyId(propertyReturn.kenlo_property_id),
    property_label: propertyLabel || null,
    property_address: propertyAddress || null,
    market_value: marketValue,
    effective_market_value: effectiveMarketValue,
    market_value_source: normalizeMarketValueSource(
      propertyReturn.market_value_source,
      marketValue != null
    ),
    estimated_current_value: estimatedCurrentValue,
  };
}
